import React, { Component } from 'react';
import LongText from '../Utils/LongText';

class Mission extends Component {
  
render() {
    const { activeButton } = this.props;
    return (
       <div style={{ all: 'unset' }}>
                {activeButton === 'about5' && (
                    <div className="about-right-section-page">
                        <h1>Mission</h1>
                    <div className="about-right-section-text">
                        <LongText maxLength={0} disable>
                            My passion is to seek the deepest most resonant, most
                            authentic truths about myself, others, and our shared human
                            experience. I believe that when we're in touch with our
                            spiritual core, tapping into our depths, we become alive
                            with the power of healing and transformation. I am an agent
                            of this transformation—an agent of positive change. I'm a
                            shining light of imagination, creativity, and intuition for
                            others to be inspired by—a leader by example, who approaches
                            problems with curiosity and an open playful attitude. When
                            we take this attitude we become excited with the richness of
                            possibilities for our lives. There is a vast ocean of
                            potential with each of us—waiting to be explored.
                        </LongText>
                    </div>
                    </div>
                )}
       </div> 
    );
  }
}

export default Mission;